import { isNativePlatform } from '../utils/platform';

const INTERNAL_HOST = 'dentalpost.net';

export function setupExternalLinkInterceptor(): void {
  if (!isNativePlatform()) return;

  document.addEventListener('click', async (e: MouseEvent) => {
    if (e.defaultPrevented) return;

    const anchor = (e.target as Element).closest('a');
    if (!anchor) return;

    const href = anchor.getAttribute('href');
    if (!href) return;

    // Only intercept external http(s) links not pointing to our own domain
    if (
      (href.startsWith('http://') || href.startsWith('https://')) &&
      !href.includes(INTERNAL_HOST)
    ) {
      e.preventDefault();
      try {
        const { Browser } = await import('@capacitor/browser');
        await Browser.open({ url: href });
      } catch {
        window.open(href, '_blank');
      }
    }
  });
}
